import { ControlModeTemplate } from '@src/types/ControlModes';
import { ControlModes, ISections } from '@src/types/Stacks';
import { convertFieldsToStackFormat } from '../../Modes/ControlModesTemplateCreateEditModal/helpers/fieldConverters';

export const mergeTemplatesIntoControlMode = (
  controlModes: ControlModes[],
  controlModeIndex: number,
  templates: ControlModeTemplate[] = [],
  templateIds?: string[],
): ControlModes[] => {
  if (controlModeIndex === null || !templates || templates.length === 0) {
    return controlModes;
  }

  const updatedControlModes = [...controlModes];
  const currentControlMode = updatedControlModes[controlModeIndex];

  // Set the control mode name based on selected templates
  if (templates.length === 1) {
    // If only one template is selected, use its name for the control mode
    currentControlMode.name = templates[0].name;
  } else if (templates.length > 1) {
    // If multiple templates are selected, use all names separated by commas
    currentControlMode.name = templates
      .map((template) => template.name)
      .join(', ');
  }

  let mergedSections: ISections[] = [];

  // Process each selected template
  templates.forEach((template) => {
    // Convert template settings to stack sections
    const templateSections = template.settings.map((setting) => ({
      controllerField: setting.controllerField,
      uiLabel: setting.uiLabel,
      fields: setting.fields.map(convertFieldsToStackFormat),
    }));

    // Add sections from the template, avoiding duplicates by controllerField
    templateSections.forEach((newSection) => {
      const existingIndex = mergedSections.findIndex(
        (section) => section.controllerField === newSection.controllerField,
      );

      if (existingIndex >= 0) {
        // Replace existing section with the new one
        mergedSections[existingIndex] = newSection;
      } else {
        // Add new section
        mergedSections.push(newSection);
      }
    });
  });

  updatedControlModes[controlModeIndex] = {
    ...currentControlMode,
    sections: mergedSections,
    templateIds:
      templateIds ||
      (templates ? templates.map((template) => template.id) : []),
  };

  return updatedControlModes;
};
